export default {
  modals: {
    top: 100,
  },
};
